import { render, staticRenderFns } from "./ServicesOpted.vue?vue&type=template&id=20d8d6a0&scoped=true&"
import script from "./ServicesOpted.vue?vue&type=script&lang=js&"
export * from "./ServicesOpted.vue?vue&type=script&lang=js&"
import style0 from "./ServicesOpted.vue?vue&type=style&index=0&id=20d8d6a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d8d6a0",
  null
  
)

export default component.exports